export default __webpack_public_path__ + "static/media/card_lumpsum_icon.a4a25744.svg";